import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  EnrollmentCenter,
  EnrollmentCenterFilters
} from '../../lib/types/models/enrollment-center/enrollment-center'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentCenters(input: PaginationRequest<EnrollmentCenterFilters> = {}) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.enrollmentCenters.getEnrollmentCenters.url, null),
        input
      )
    )
    .get<PaginationResponse<EnrollmentCenter>>()
}
